import { canUseLocalStorage } from '@ps/web-core-utils';
import produce from 'immer';
import { isEmpty, merge } from 'lodash';

import { PKR_INITIAL_STATE, PKR_LOCAL_STORAGE } from '@swf/poker';

import type { HGLocalStorage } from '../../types/common';

export const setLocalStorageItem = (state = PKR_INITIAL_STATE, payload: HGLocalStorage) => {
  if (!canUseLocalStorage) return state;

  const ls = JSON.parse(localStorage.getItem(PKR_LOCAL_STORAGE) ?? '{}');

  // If redux state is empty and lsStore is not => hydrate redux with ls state
  const source = isEmpty(ls) ? PKR_INITIAL_STATE.localStorage : ls;

  try {
    const newState = merge({}, source, payload);
    if (isEmpty(newState)) {
      return state;
    }

    const updatedState = produce(state, (draft) => {
      draft.localStorage = newState;
    });

    localStorage.setItem(PKR_LOCAL_STORAGE, JSON.stringify(newState));

    return updatedState;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);

    return state;
  }
};
